function EnrolleeAssociationThread() {
    "use strict";
    this.__type = 'EnrolleeAssociationThread:www.veritracks.com';
    this.Id = -1;

    this.PointGroupingId = -1;
    this.IsActive = 1;
    this.ThreadId = '';
    this.UserId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeAssociationThread;
}